import { render, staticRenderFns } from "./RightSideBar.vue?vue&type=template&id=43359584&scoped=true&"
import script from "./RightSideBar.vue?vue&type=script&lang=js&"
export * from "./RightSideBar.vue?vue&type=script&lang=js&"
import style0 from "./RightSideBar.vue?vue&type=style&index=0&id=43359584&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43359584",
  null
  
)

export default component.exports